/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useEffect, useState } from 'react';
import Flex from '../Utils/Flex';
import InputMessage from './InputMessage';
import kebabCase from 'lodash/kebabCase';
import isEqual from 'lodash/isEqual';
import concat from 'lodash/concat';
import OptionButton from '../Form/OptionButton';
import Typography from '../Typography';
import { useCallback } from 'react';

const valueToArray = value => {
	if (value === undefined || value === null) {
		return [];
	}
	return Array.isArray(value) ? value : [value];
}

const CheckboxGroup = ({
	max = null,
	options,
	singleColumn = false,
	state,
	message,
	type = 'checkbox',
	valuesAsNumbers = false,
	submitOnChange = false,
	setValue = () => {},
	value = [],
	xStyle = {},
	messageProps = {},
	descriptionFieldProps = null,
	label = null,
	name,
	className = '',
}) => {
	const [checklist, setChecklist] = useState(value);

	useEffect(() => {
		if(type == 'checkbox' && !valuesAsNumbers && value != null && !Array.isArray(value)) {
			setValue(valueToArray(value));
		}
	}, [setValue, type, value, valuesAsNumbers])

	useEffect(() => {
		if (!isEqual(checklist, value)) {
			setChecklist(value);
		}
	}, [checklist, value, setChecklist]);

	const isChecked = useCallback(
		el => {
			const list = Array.isArray(checklist) ? checklist : [checklist];
			return list.findIndex(i => el === i) > -1;
		},
		[checklist],
	);

	const handleChange = useCallback(
		e => {
			if (type == 'checkbox') {
				if (e.target.checked) {
					const slice = max ? -1 * (max - 1) : 0;
					const slicedlist = max === 1 ? [] : checklist.slice(slice);
					const newList = [...slicedlist, e.target.value];
					setValue(newList);
				} else {
					const newList = checklist.filter(el => el !== e.target.value);
					setValue(newList);
				}
			} else if (type == 'radio') {
				setTimeout(() => {
					e.currentTarget?.blur()
					console.log('blur')
				}, 200);
				setValue(e.target.value, { submit: submitOnChange });
			}
		},
		[type, checklist, setValue, submitOnChange, max],
	);

	if (!Array.isArray(options)) {
		console.error('CheckboxGroup: options must be an array');
		return null;
	}

	return (
		<div css={theme => (typeof xStyle === 'function' ? xStyle(theme) : { ...xStyle })} className={className}>
			{label ? (
				<Typography variant="body2" component="h3" xStyle={{ marginTop: 60, marginBottom: 48, fontWeight: 500 }}>
					{label}
				</Typography>
			) : null}
			<Flex flexWrap="wrap" marginLeft={-9} marginRight={-9}>
				{(descriptionFieldProps?.option ? concat(options, [descriptionFieldProps?.option]) : options).map((el, index) => (
					<div
						key={`area-${kebabCase(label ?? name ?? 'na')}-${kebabCase(el)}`}
						css={theme => ({
							padding: '15px 9px',
							flex: '0 0 100%',
							'.option-button': {
								width: '100%',
							},
							[theme.breakpoints.up('md')]: {
								flex: singleColumn ? '0 0 100%' : '0 0 50%',
								overflow: 'hidden',
								'.option-button': {
									width: 'calc(100% - 18px)',
									'&>label': {
										minWidth: 250,
									},
								},
							},
						})}
						className="option-wrapper"
					>
						<OptionButton
							id={`area-${kebabCase(el)}`}
							value={el}
							checked={isChecked(valuesAsNumbers ? index + 1 : el)}
							onChange={valuesAsNumbers ? (e) => handleChange({ ...e, target: { ...e.target, value: index + 1 } }) : handleChange}
							className="option-button"
							textInputProps={el === descriptionFieldProps?.option ? { ...descriptionFieldProps, placeholder: ': escrever' } : null}
						>
							{el}
						</OptionButton>
					</div>
				))}
			</Flex>

			<InputMessage state={state} {...messageProps}>
				{[message]}
			</InputMessage>
			{descriptionFieldProps && descriptionFieldProps.message && (
				<InputMessage state={descriptionFieldProps.state} {...messageProps}>
					{descriptionFieldProps.message}
				</InputMessage>
			)}
		</div>
	);
};

export default CheckboxGroup;
